// =====================================
//
//   付款結果 Controller
//   Author: Aegg
//   createtime: 2016 / 03 / 12
//	 updatetime: 2016 / 03 / 12
//
// =====================================

window.InifECMobileApp.controller("PaymentSinopacCreditCardController", ['$scope', '$state', '$timeout', 
    '$rootScope', '$stateParams', 'UserService', 'OrderService',
	function($scope, $state, $timeout, 
        $rootScope, $stateParams, UserService, OrderService) {

        var getOrderInfo = function() {
            $scope.isLoading = true;
            OrderService.getOrderInfo($scope.orderid).then(function(result) {
                if(result) {
                    $scope.order = result;

                    if($scope.order.orderstatus != 250 && $scope.order.orderstatus != 300){
                        $state.go(window.STATES.ORDER, {orderid: $scope.orderid});
                    } else {
                        pay();    
                    }
                }

                $scope.isUploadError = false;
                $scope.isLoading = false;
            }, function(error) {
                if(error && (error.code == 'error.rscNotExist' || error.code == 'error.privilege.noReadable')) {
                    $scope.isOrderNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isUploading = false;
                $scope.isLoading = false;
            });
        }
        var pay = function() {
            if(!$scope.order || $scope.isPaying) {
                return;
            }

            var orderid = $scope.orderid,
                paymentmethod = $scope.order.paymentmethod,
                totalamount = $scope.order.totalamount;
            $scope.isPaying = true;
            OrderService.payForOrder(orderid, paymentmethod, totalamount).then(function(result) {
                if(result) {
                        // 因為信用卡付款會直接導頁，所以不讓讀取狀態停止，不然會很奇怪
                } else {
                    $scope.isError = true;
                    $scope.isPaying = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isPaying = false;
            });
        }
        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;
                getOrderInfo();
            }, function(error) {
                $scope.isLogin = false;

                $state.go(window.STATES.HOME);
            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.order;


        //==========================
        //  Methods
        //==========================
        

        //==========================
        //  Init
        //==========================
        init();
	}
]);